import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { API_ENDPOINTS, API_URL } from "src/app/shared/interfaces/global";
import { loginDTO } from "src/app/shared/interfaces/shared.interface";
import { UserSessionDto } from "src/app/shared/interfaces/UserSessionDto";
import { ApiHandlerService } from "../api-handler.service";
import { TenantImpersonationService } from "../tenant-impersonation.service";

@Injectable({
  providedIn: "root",
})
export class AuthService extends ApiHandlerService {
  constructor(httpClient: HttpClient, private tenantImpersonation: TenantImpersonationService) {
    super(httpClient);
  }

  login(data: loginDTO) {
    return (
      this.Post(API_URL + API_ENDPOINTS.loginUser, data)
        // .pipe(map((x) => x.Response))
        .toPromise()
    );
  }

  public getAccessToken(): string | null {
    return localStorage.getItem("accessToken");
  }

  public getTenantAccessToken(): string | null {
    return this.tenantImpersonation.token();
  }

  public isAuthenticated(): boolean | null | "" {
    let accessToken = this.getAccessToken();
    return accessToken && accessToken.length > 0;
  }

  public async getUserModel() {
    let token = this.getAccessToken() || "";
    if (this.isAuthenticated()) {
      let data = JSON.parse(atob(token.split(".")[1])) as UserSessionDto;
      return data;
    }
    return new UserSessionDto();
  }
}
